"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseColor = void 0;
var BaseColor;
(function (BaseColor) {
    BaseColor["LightBlue"] = "light_blue";
    BaseColor["Green"] = "green";
    BaseColor["Orange"] = "orange";
    BaseColor["Gray"] = "gray";
    BaseColor["Red"] = "red";
})(BaseColor = exports.BaseColor || (exports.BaseColor = {}));
var colorToCN = function (type) {
    return "respectkit__color_" + type;
};
exports.default = colorToCN;
//# sourceMappingURL=index.js.map